import { call, takeLatest } from 'redux-saga/effects';
import { VISIBILITY_CHANGE, VisibilityChange } from '../actions';
import { clearUser } from '../../auth/saga';
import { getBearerTokenFromLocalStorage, renewTokensFromAWS } from 'services/tokenLocalStorage';

export function* visibilityChangeSaga({ visible }: VisibilityChange) {
  if (!visible) {
    return;
  }

  const token = getBearerTokenFromLocalStorage();

  if (!token.value || token.expired) {
    const refreshToken = window.localStorage.getItem('REFRESH_TOKEN');
    if (refreshToken) {
      try {
        yield call(renewTokensFromAWS);
        // Renewal succeeded — session recovered, stay logged in
      } catch {
        yield clearUser();
      }
    } else {
      yield clearUser();
    }
  }

}

export function* watchVisibilityChange() {
  yield takeLatest(VISIBILITY_CHANGE, visibilityChangeSaga);
}
